import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeroCarousel from "../components/HeroCarousel";
import HomeFilters from "../components/HomeFilters";
import ProductCard from "../components/ProductCard";
import CraftStories from "../components/CraftStories";
import LeaveReviewSection from "../components/ReviewsSection";
import ProductVideos from "../components/ProductVideos";
import Footer from "../components/Footer";
import { useFilters } from "../context/FilterContext";
import { fetchProducts } from "../lib/api";

export default function HomePage() {
  const { buildParams, isFiltering } = useFilters();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchProducts(buildParams())
      .then(setProducts)
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(buildParams())]);

  return (
    <main data-testid="home-page" className="bg-[#0A0A0A]">
      <HeroCarousel />
      <HomeFilters />

      {/* Product grid */}
      <section
        data-testid="home-product-grid"
        className="max-w-[1500px] mx-auto px-6 md:px-10 pt-10 md:pt-16 pb-16 md:pb-24"
      >
        <div className="flex items-baseline justify-between mb-8 md:mb-10 flex-wrap gap-3">
          <h2
            className="font-serif-display"
            style={{ fontSize: 40, color: "#FFFFFF", letterSpacing: "-0.01em", lineHeight: 1, fontWeight: 500 }}
          >
            {isFiltering ? "Filtered" : "The Edit"}
          </h2>
          <Link
            to="/shop"
            data-testid="home-view-all-link"
            className="font-ui transition-colors hover:text-[#F5D565]"
            style={{ fontSize: 13, fontWeight: 600, color: "rgba(255,255,255,0.7)", letterSpacing: "0.2em", textTransform: "uppercase" }}
          >
            View All →
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[3/4] bg-[#141414] animate-pulse" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="py-20 text-center font-serif-display italic" style={{ fontSize: 24, color: "rgba(255,255,255,0.6)" }}>
            No pieces match these filters.
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>

      <CraftStories />
      <LeaveReviewSection />
      <ProductVideos />
      <Footer />
    </main>
  );
}
